const hideDisconnectLink = function () {
    if (document.body.classList.contains('logged-in')) {
        if (document.body.classList.contains('woocommerce-account')) {
            if (document.querySelector('.woocommerce-MyAccount-navigation-link.woocommerce-MyAccount-navigation-link--dashboard').classList.contains('is-active')) {
                document.querySelector('.woocommerce-MyAccount-content').classList.add('dashboard');
                const helloP = document.querySelector('.woocommerce-MyAccount-content p:first-of-type');
                const helloText = helloP.textContent.split(" ");
                helloP.textContent = "Bonjour " + helloText[1];
            }
        }
    }
}

addFunctionOnWindowLoad(hideDisconnectLink);